import { useEffect } from 'react';
import { useSidebarLayoutContext } from 'controllers/SidebarLayout/SidebarLayout';
import { useFilterVisibility } from '../components/useFilterVisibility';

export const useSidebarDisabledEffect = (isLoading: boolean) => {
    const { enableSidebar, disableSidebar } = useSidebarLayoutContext();

    const {
        instruments: instrumentFilters,
        genres: genreFilters,
        sfxs: sfxFilters,
        isBpmAndKeyVisible,
    } = useFilterVisibility();

    useEffect(() => {
        if (isLoading) {
            return;
        }

        const hasInstruments = instrumentFilters.length > 0;
        const hasGenre = genreFilters.length > 0;
        const hasSfx = sfxFilters.length > 0;

        const hasSomeVisibleTab =
            hasInstruments || hasGenre || hasSfx || isBpmAndKeyVisible;
        if (hasSomeVisibleTab) {
            enableSidebar();
        } else {
            disableSidebar();
        }
    }, [
        isLoading,
        instrumentFilters,
        genreFilters,
        sfxFilters,
        isBpmAndKeyVisible,
        enableSidebar,
        disableSidebar,
    ]);
};
